import React from "react";
import {Link} from "react-router-dom";
import {LucanTitle} from "./Lucan";

function TheLybianSerpents() {
    return (
        <div className="row">
            <div className="col-md-8 offset-md-2">
                <h1 className="text-center"><Link to="/translation/lucan/the-lybian-serpents">The Lybian Serpents</Link>
                </h1>
                <LucanTitle/>
                <div className="text-center">
                    <a href="https://www.poetryintranslation.com/PITBR/Latin/PharsaliaIXmaster.php">Original Text</a>
                </div>
                <hr/>
                <p>
                    The first plague reared its head above the sand:<br/>
                    The broad-necked <em>asp</em>, whose venom causes sleep.<br/>
                    Their throats are full of blood and venom thick,<br/>
                    More dense with bile than any other snake.
                </p>
                <p>
                    Lovers of heat, they ever shun the cold,<br/>
                    Lurking through sandy lands beyond the Nile.<br/>
                    Yet we—will greed for profit never end?—<br/>
                    Import this bane to Italy for trade.
                </p>
                <p>
                    There too the <em>haemorrhois</em> unfolds its coils,<br/>
                    Its huge fangs leave its bleeding victims dead.<br/>
                    The <em>chersydros</em> inhabits fickle Sidra,<br/>
                    The <em>chelydrus</em> behind leaves trails of smoke.
                </p>
                <p>
                    The <em>cenchris</em> glides full straight, its belly stained<br/>
                    With checkered designs surpassing Theban serpentine.<br/>
                    <em>Ammodytes</em> hides, its color like sand;<br/>
                    <em>Cerastes</em> creeps along with curving spine.
                </p>
                <p>
                    <em>Cytale</em> sheds its skin in winter’s frost;<br/>
                    There’s parched old <em>dipsas</em>; and the <em>amphisbaena,</em><br/>
                    Whose two heads face about; and the <em>natrix,</em><br/>
                    Who poisons wells; and flying <em>iaculus.</em>
                </p>
                <p>
                    The greedy <em>prester</em> lies with foaming jaws;<br/>
                    The <em>seps</em> dissolves its victims, flesh and bone.<br/>
                    The <em>basilisk</em> frights all the other snakes;<br/>
                    It kills before its venom,<br/>
                    Rules the empty sands.
                </p>
                <p>
                    You <em>dragons</em> too, who glitter with gold sheen,<br/>
                    Through most lands crawl pacific and divine—<br/>
                    In fiery Africa you’re rendered deadly.
                </p>
                <p>
                    You draw the air of heaven with your wings,<br/>
                    Then chase whole herds of cattle, coiling round<br/>
                    The mighty bulls and crushing with your tail.
                </p>
                <p>
                    Nor can the elephant escape your ire:<br/>
                    Consigning all to death<br/>
                    You venomless destroy.
                </p>
                <p>
                    Among these lands did Cato march his troop,<br/>
                    Witnessing cruel fate take man after man,<br/>
                    Who strangely died from but the slightest wounds.
                </p>
                <p>
                    Thus Aulus, an Etruscan standard-bearer,<br/>
                    Trod on a <em>dipsas</em> and was lightly bit.<br/>
                    He scarcely felt the bite, was free of pain;<br/>
                    The wound looked harmless, threatening no ill.
                </p>
                <p>
                    But hidden venom rises—heat devours,<br/>
                    Seizes marrow, scorches, wasting innards.<br/>
                    The poisons sapped the humours from his viscera,<br/>
                    Withering the tongue in his dried-up mouth.
                </p>
                <p>
                    No sweat ran down his weakened limbs; his eyes<br/>
                    Could form no tears; Till neither shouts nor pride<br/>
                    Could halt the man, who hurled away the standard,<br/>
                    Wildly seeking water<br/>
                    At the venom’s behest.
                </p>
                <p>
                    He would have burned though plunged into the Rhone,<br/>
                    The Don, the Po—though drenched in Nile’s flood.<br/>
                    Libya’s scorching soil is seeped in death—<br/>
                    Don’t credit <em>dipsas</em> for the man's demise.
                </p>
                <p>
                    Men look for water deep in barren sand,<br/>
                    Then run to Sidra's shores and swallow brine:<br/>
                    The wave relieves, but only for a time.
                </p>
                <p>
                    Thinking it merely thirst, the poisoned Aulus<br/>
                    Reached for his sword and opened up a vein,<br/>
                    Then, thirsting, filled his mouth with his own blood.<br/>
                </p>
                <p>
                    <strong>Lucan, "Pharsalia", Book IX: 700-760</strong>
                </p>
                <p>
                    <em>Trans. Porter James, 2024-01-15</em>
                </p>
            </div>
        </div>
    );
}

export default TheLybianSerpents
